import DataTable from "../../DataTable/DataTable";
import NoData from "../../Loading/NoData";
import { HeadingTitle } from "../ModalContainer";

const ALTERNATE_HEADER = [
  <>
    A-Inventory <br />
    Available Warehouse
  </>,
  <>
    B-Inventory <br />
    available in Blocked
  </>,
  <>
    E-Manufacture <br />
    Location
  </>,
  <>
    F-Manufacture <br />
    Last Node Qty
  </>,
  <>
    Net Available <br />
    (Including wip)
  </>,
  <>
    J-Orders <br /> Received But
  </>,
  <>
    D-Temp Hold <br />
    Inventory
  </>,
];

const AlternateSKU = ({ close, alternate_sku }) => {
  return (
    <div>
      <HeadingTitle title={"Alternate SKU"} center={false} closeModal={close} />

      <div className="table__flow__row">
        <div className="table-wrapper-pagination">
          <div className="table-container-pagination">
            {alternate_sku && alternate_sku?.length > 0 ? (
              <DataTable
                items_per_page={10}
                page={1}
                header={ALTERNATE_HEADER}
                alternateSKU={alternate_sku && alternate_sku}
              />
            ) : (
              <NoData title={"No Results Found"} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlternateSKU;
